<template>
    <EasyPlayer
            :videoUrl="flvUrl"
            :aspect="aspect"
            :live="live"
            :fluent="fluent"
            :autoplay="autoplay"
            stretch
    />
</template>

<script>
    import EasyPlayer from "@easydarwin/easyplayer";

    export default {
        components: {EasyPlayer},
        props: ['sn'],
        data() {
            return {
                autoplay: true,
                live: true,
                fluent: true,
                aspect: "16:9",
                flvUrl: ''
            }
        },
        computed: {},
        mounted() {
            this.player();
        },
        methods: {
            urlIsOk(url, resolve) {
                const controller = new AbortController()
                const {signal} = controller
                fetch(url, {signal}).then(ret => {
                    const {status} = ret
                    if (200 === status) {
                        resolve()
                        controller.abort()
                    } else {
                        setTimeout(() => this.urlIsOk(url, resolve), 500)
                    }
                }).catch(err => {
                    setTimeout(() => this.urlIsOk(url, resolve), 500)
                })


            },
            player() {
                this.$http.video.api.mega.startStream({sn: this.sn})
                    .then(res => {
                        if (res) {
                            this.urlIsOk(res.data.body.httpFlvUrl,()=>{
                                this.flvUrl = res.data.body.httpFlvUrl;
                                this.heartbeat();
                            })
                        }
                    })
            },
            heartbeat() {
                this._timer = setInterval(this.keep, 9 * 1000)
            },
            keep() {
                this.$http.video.api.mega.keepStream({sn: this.sn})
            }
        },
        destroyed() {
            clearInterval(this._timer)
        }
    }
</script>

<style lang="less" scoped>
</style>